import React, { useEffect, forwardRef } from "react";

const VideoPlayer = forwardRef(({ videoUrl, playing, title, small = false, controls = true }, ref) => {
    console.log("VideoPlayer", videoUrl, playing, title, small);
    useEffect(() => {
        if (ref?.current) {
            // Reload the video when videoUrl changes
            ref.current.load();
            if (playing) {
                ref.current.play();
            } else {
                ref.current.pause();
            }
        }
    }, [videoUrl, playing, ref]);

    if (!videoUrl) return null;

    return (
        <div className="">
            <h2 className="text-xl font-semibold text-white mb-4">{title}</h2>
            <video
                ref={ref}
                // uniform display height so source and processed videos render
                // the same size regardless of their native resolutions
                className={`video-player ${small ? "h-[100px]" : "h-[55vh] w-auto max-w-full"}`}
                controls={controls}
                preload="auto"
            >
                <source src={videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
});

export default VideoPlayer;
